import React from "react";
import Page01Component from "./Page01Component";
// import Page02Component from "./Page02Component";
// import Page03Component from "./Page03Component";
// import Page04Component from "./Page04Component";
// import Page05Component from "./Page05Component";
// import Page06Component from "./Page06Component";
// import Page07Component from "./Page07Component";
import Home from "./../../images/icons/barra-dash/home.svg";
import Siedco from "./../../images/icons/barra-dash/filtro1.svg";
import Pie from "./../../images/icons/barra-dash/pie-chart.svg";
import Secad from "./../../images/icons/barra-dash/filtro2.svg";
import Bar from "./../../images/icons/barra-dash/bar-chart.svg";

import { FORM } from "./../../constants/strings/StringsDashboard";
import { initMap } from "./../../Infroms/containers/Map";
import "./../navigationButton.css";
var mapUp, mapDown;
const data = [
  {
    action: [],
    icon: Secad,
    label: "Llamadas 123",
    anchor: "llamadas-123",
  },
  {
    action: [],
    icon: Pie,
    label: "Llamadas 123 por comunas",
    anchor: "llamadas-123-c-v",
  },
  {
    action: [],
    icon: Siedco,
    label: "Denuncias",
    anchor: "denuncias",
  },
  {
    action: [],
    icon: Bar,
    label: "Denuncias por delitos",
    anchor: "denuncias-delitos",
  },
];
class InformGenerated extends React.Component {
  setMapa = () => {
    initMap("mapSecad", mapUp, this.props.data.mapSecad, {
      user: { users: { perfil: "this.props.perfil" } },
    });
    initMap("mapSiedco", mapDown, this.props.data.mapSiedco, {
      user: { users: { perfil: "this.props.perfil" } },
    });
  };
  componentDidMount() {
    this.setMapa();
  }
  componentDidUpdate = () => {
    this.setMapa();
  };

  goToanchor = (anchor) => {
    var url = window.location.href;
    window.location.href = "#" + anchor;
    window.history.replaceState(null, null, url);
  };

  render() {

    return (
      <>
        {/* /////////////////// */}
        <div className="fab-container" align="center">
          <div
            className="navigation-filter fab fab-icon-holder "
            onClick={() => this.goToanchor("resumen")}
          >
            <img src={Home} alt="icono" />
            <span className="tooltiptext">Resumen</span>
          </div>
          <ul className="fab-options">
            {data.map((item, index) => {
              return (
                <li key={"item-floating-action-button-" + index}>
                  <div className="fab-icon-container">
                    <div
                      className="navigation-filter fab-icon-holder "
                      onClick={() => this.goToanchor(item.anchor)}
                    >
                      <img src={item.icon} alt="icono" />
                      <span className="tooltiptext">{item.label}</span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        {/* /////////////////// */}
        <Page01Component data={this.props.data} ancla="resumen" />
        {/* <Page02Component data={this.props.data} ancla="llamadas-123" />
        <Page03Component data={this.props.data} ancla="llamadas-123-c-v" />
        <Page04Component data={this.props.data} />
        <Page05Component data={this.props.data} /> */}
        {/* <Page06Component data={this.props.data} ancla="denuncias" /> */}
        {/* <Page07Component data={this.props.data} ancla="denuncias-delitos" /> */}
        <div className="content-line" style={{ height: "100px" }}>
          <div className="line line-100">
            {/* <button className="btn-area btn-area-green" onClick={this.props.onSave}>
            {FORM.SAVE}
          </button> */}
            <button
              className="btn-area btn-area-grey"
              onClick={this.props.onCancel}
            >
              {FORM.CANCEL}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default InformGenerated;
